module.exports = __webpack_public_path__ + "img/blueSapphire.fa55336.webp";